var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibrairies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8968 6.53125L14.7441 10.0833C14.6065 10.3316 14.3706 10.5512 14.0364 10.7422C13.7219 10.9141 13.4172 11 13.1223 11H1.32697C1.05175 11 0.845331 10.8854 0.707719 10.6562C0.570107 10.4271 0.570107 10.1979 0.707719 9.96875L2.86036 6.41667C2.99798 6.1684 3.22405 5.95833 3.5386 5.78646C3.8728 5.59549 4.18734 5.5 4.48222 5.5H16.2775C16.5528 5.5 16.7592 5.61458 16.8968 5.84375C17.0344 6.07292 17.0344 6.30208 16.8968 6.53125ZM4.48222 4.58333C4.14802 4.58333 3.82365 4.64062 3.50911 4.75521C3.19457 4.86979 2.90951 5.03212 2.65395 5.24219C2.41804 5.43316 2.21162 5.67187 2.03469 5.95833L0 9.33854V1.375C0 0.993056 0.137612 0.668403 0.412836 0.401042C0.68806 0.133681 1.02226 0 1.41544 0H6.13356L8.02082 1.83333H12.7389C13.1321 1.83333 13.4663 1.96701 13.7415 2.23437C14.0168 2.50174 14.1544 2.82639 14.1544 3.20833V4.58333H4.48222Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrairies);
export default __webpack_public_path__ + "static/media/librairies.b7b8d31c.svg";
export { ForwardRef as ReactComponent };